/* eslint-disable import/prefer-default-export */
export const errorTypes = {
  NO_PLANS: 'NO_PLANS',
  NO_PLOTS: 'NO_PLOTS',
};

export const errorCodes = {
  PLAN_USED_IN_CROP_ROTATIONS: 69,
};
